/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { validatePriceDifferencePurchase } from 'services/Criteria';

function FormPrice({ parent, edit }) {
  const [attr, setAttr] = useState(parent);
  const [focus, setFocus] = useState(false);
  const [priceChange, setPriceChange] = useState(parent.price);
  const [originalPrice] = useState(parent.price);
  const isPriceExceedsTolerance = () => {
    if (parseFloat(attr.price) === parseFloat(originalPrice)) {
      return false;
    }

    const currentPrice = parseFloat(attr.price) || 0;
    const original = parseFloat(originalPrice) || 0;

    return !validatePriceDifferencePurchase(original, currentPrice);
  };

  const send = () => {
    if (attr.price !== priceChange) {
      setPriceChange(attr.price);
      edit({ id: attr.id, price: attr.price }, 'PRICE');
    }
  };

  const renderPriceInput = () => {
    const isExceeded = isPriceExceedsTolerance();

    return (
      <MDInput
        value={attr.price}
        type='number'
        onChange={(e) => setAttr({ ...attr, price: e.target.value })}
        onFocus={(e) => {
          setFocus(true);
          e.target.select();
        }}
        onBlur={() => {
          if (focus) {
            setFocus(false);
            send();
          }
        }}
        variant='standard'
        fullWidth
        inputProps={{
          maxLength: 20,
          autoComplete: 'off',
          className: 'text-right',
          sx: {
            minWidth: 80,
            color: isExceeded ? '#f44336' : 'inherit',
            fontWeight: isExceeded ? 'bold' : 'normal',
          },
        }}
      />
    );
  };

  const renderWarningMessage = () => {
    if (!isPriceExceedsTolerance()) return null;

    return (
      <MDTypography
        variant='caption'
        color='error'
        sx={{
          fontSize: '0.7rem',
          display: 'block',
          textAlign: 'center',
          mt: 0.5,
        }}
      />
    );
  };

  return (
    <MDBox
      noValidate
      component='form'
      role='form'
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
    >
      {renderPriceInput()}
      {renderWarningMessage()}
    </MDBox>
  );
}

FormPrice.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
  }).isRequired,
  edit: PropTypes.func.isRequired,
};

export default FormPrice;
